import {
  Configuration,
  type ConfigurationParameters,
  GuaranteeApi
} from './hau-itde-guarantee-free-portal-api';

//set base path of api
const configParams: ConfigurationParameters = {
  basePath: import.meta.env.VITE_PORTAL_API_BASE_URL
};
const config = new Configuration(configParams);

/**
 * Use these exports for api access
 * @exports GuaranteeApi callable configured setting api
 */
export const guaranteeApi = new GuaranteeApi(config);
